<div class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Action Violation</p>
    </header>
    <app-actionviolation [violation]="violation"></app-actionviolation>
  </div>
</div> 